<template>
    
    <div class="article-title">

        <a class="article-title__wrapper"
            :href="article.href"
            v-if="clickable">
            <Thumbnail :article="article" />
            <span class="text-title">{{ article.title }}</span>
        </a>

        <span class="article-title__wrapper"
            v-if="!clickable">
            <Thumbnail :article="article" />
            <span class="text-title">{{ article.title }}</span>
        </span>

    </div>

</template>

<script>
import Thumbnail from '@/components/thumbnail/Thumbnail.vue'

export default {

    props: {

        article: Object

    },
    
    computed: {
        
        clickable: function () {
            return this.article.slug
        },

    },

    components: {
        Thumbnail
    }
}
</script>

<style scoped>

.article-title { 
    margin: 1rem 0;
    overflow: hidden;
}

.article-title .article-title__wrapper {
    display: flex;
    align-items: center;
}

.article-title .article-title__wrapper .thumbnail {
    margin-right: 1.5rem;
}

.text-title {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

</style>